import { urlApiCourse } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import {
  IModule,
  ICoursesDetail,
  IQueryGetCoursesOfStudent,
  ICourseSelect,
  IPayloadGetModulesOfCourse,
  IModuleSelect,
} from '~/utils/interface/course';

export const courseApi = {
  getListCourses() {
    const url = `${urlApiCourse.getList}`;
    return axiosClient.get<IBaseResponse<IModule[]>>(url);
  },

  getDetailCourse(coursesId: string, lessonId: string) {
    const url = `${urlApiCourse.getDetail(coursesId, lessonId)}`;
    return axiosClient.get<IBaseResponse<ICoursesDetail>>(url);
  },

  getCoursesOfStudent(params: IQueryGetCoursesOfStudent) {
    const url = `${urlApiCourse.getCoursesOfStudent}`;
    return axiosClient.get<IBaseResponse<ICourseSelect[]>>(url, { params });
  },

  getModulesOfCourse(params: IPayloadGetModulesOfCourse) {
    const url = `${urlApiCourse.getModulesOfCourse(params.courseId)}`;
    return axiosClient.get<IBaseResponse<IModuleSelect[]>>(url);
  },
};
